import { ME_ROUTE, STARTPAGE_ROUTE } from "./consts";
import Taplink from "../components/pages/Taplink";
import SocialLinks from "../components/pages/SocialLinks";

export const publicRoutes = [
    {
        path: STARTPAGE_ROUTE,
        Component: <Taplink />
    },
    {
        path: ME_ROUTE,
        Component: <SocialLinks />
    },
]